const PLAGIARISM_SCROLL = 'plagiarism-scroll'

export const MODAL_CONTENT = `${PLAGIARISM_SCROLL}-modal-content`
export const CLOSE_BUTTON = `${PLAGIARISM_SCROLL}-close-button`
export const TITLE_ICON = `${PLAGIARISM_SCROLL}-title-icon`
export const GET_STARTED_BUTTON = `${PLAGIARISM_SCROLL}-create-acount-button`
